import { Component } from '@angular/core';

@Component({
    selector: 'app-lovable-right-rail-footer',
    templateUrl: './lovable-right-rail-footer.component.html',
    styleUrls: ['./lovable-right-rail-footer.component.css'],
})
export class LovableRightRailFooterComponent {}
